import React from 'react';
import { Activity } from 'lucide-react';
interface ActivityLogEntry {
  id: string;
  timestamp: string;
  action: string;
  category: 'technician' | 'distributor' | 'invoice' | 'rental' | 'system' | 'dispatch' | 'onsiteprep';
  details: string;
  user: string;
}
interface ActivityLogProps {
  logs: ActivityLogEntry[];
  filter: string;
  setFilter: (filter: string) => void;
}
export function ActivityLog({
  logs,
  filter,
  setFilter
}: ActivityLogProps) {
  const getCategoryColor = (category: string) => {
    switch (category) {
      case 'technician':
        return 'bg-green-100 text-green-800 border-green-200';
      case 'distributor':
        return 'bg-purple-100 text-purple-800 border-purple-200';
      case 'invoice':
        return 'bg-yellow-100 text-yellow-800 border-yellow-200';
      case 'rental':
        return 'bg-blue-100 text-blue-800 border-blue-200';
      case 'dispatch':
        return 'bg-orange-100 text-orange-800 border-orange-200';
      case 'onsiteprep':
        return 'bg-teal-100 text-teal-800 border-teal-200';
      case 'system':
        return 'bg-slate-100 text-slate-800 border-slate-200';
      default:
        return 'bg-slate-100 text-slate-800 border-slate-200';
    }
  };
  const filteredLogs = logs.filter(log => filter === 'all' || log.category === filter);
  return <div className="p-6" data-id="element-67">
      <div className="mb-6 flex items-center justify-between" data-id="element-68">
        <div data-id="element-69">
          <h2 className="text-xl font-semibold text-slate-800 mb-2" data-id="element-70">
            Activity Log
          </h2>
          <p className="text-sm text-slate-600" data-id="element-71">
            Track all admin actions and system events
          </p>
        </div>
      </div>

      {/* Filters */}
      <div className="flex gap-2 mb-6 overflow-x-auto" data-id="element-72">
        <button onClick={() => setFilter('all')} className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${filter === 'all' ? 'bg-blue-600 text-white' : 'bg-slate-100 text-slate-700 hover:bg-slate-200'}`} data-id="element-73">
          All ({logs.length})
        </button>
        <button onClick={() => setFilter('technician')} className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${filter === 'technician' ? 'bg-green-600 text-white' : 'bg-slate-100 text-slate-700 hover:bg-slate-200'}`} data-id="element-74">
          Technicians (
          {logs.filter(log => log.category === 'technician').length})
        </button>
        <button onClick={() => setFilter('distributor')} className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${filter === 'distributor' ? 'bg-purple-600 text-white' : 'bg-slate-100 text-slate-700 hover:bg-slate-200'}`} data-id="element-75">
          Distributors (
          {logs.filter(log => log.category === 'distributor').length})
        </button>
        <button onClick={() => setFilter('invoice')} className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${filter === 'invoice' ? 'bg-yellow-600 text-white' : 'bg-slate-100 text-slate-700 hover:bg-slate-200'}`} data-id="element-76">
          Invoices ({logs.filter(log => log.category === 'invoice').length})
        </button>
        <button onClick={() => setFilter('system')} className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap ${filter === 'system' ? 'bg-slate-600 text-white' : 'bg-slate-100 text-slate-700 hover:bg-slate-200'}`} data-id="element-77">
          System ({logs.filter(log => log.category === 'system').length})
        </button>
      </div>

      {/* Activity Log List */}
      <div className="space-y-2" data-id="element-78">
        {filteredLogs.map(log => <div key={log.id} className="p-4 border border-slate-200 rounded-lg hover:border-slate-300 transition-colors" data-id="element-79">
            <div className="flex items-start justify-between mb-2" data-id="element-80">
              <div className="flex items-center gap-3" data-id="element-81">
                <span className={`text-xs px-2 py-1 rounded border font-medium ${getCategoryColor(log.category)}`} data-id="element-82">
                  {log.category.toUpperCase()}
                </span>
                <span className="font-semibold text-slate-800" data-id="element-83">
                  {log.action}
                </span>
              </div>
              <span className="text-xs text-slate-500" data-id="element-84">
                {new Date(log.timestamp).toLocaleString()}
              </span>
            </div>
            <p className="text-sm text-slate-600" data-id="element-85">{log.details}</p>
            <div className="mt-2 text-xs text-slate-500" data-id="element-86">By: {log.user}</div>
          </div>)}
      </div>

      {filteredLogs.length === 0 && <div className="text-center py-12" data-id="element-87">
          <Activity size={48} className="text-slate-300 mx-auto mb-4" data-id="element-88" />
          <p className="text-slate-600" data-id="element-89">No activity logs found</p>
          <p className="text-sm text-slate-500 mt-1" data-id="element-90">
            {filter !== 'all' ? 'Try changing the filter' : 'Activity will be logged here'}
          </p>
        </div>}
    </div>;
}